import { ComposeUniqueState } from '../store/schema/FilePickerUploadConfiguration';
import FilePickerActionMessageType, {
    actionMessageMap,
} from '../types/FilePickerActionMessageType';
import { format } from 'owa-localize';

export default function getMessageForComposeUniqueState(
    composeUniqueState: ComposeUniqueState,
    fileProviderName: string
): string {
    switch (composeUniqueState) {
        case ComposeUniqueState.PlainText:
            return format(
                actionMessageMap[FilePickerActionMessageType.SharePlainText](),
                fileProviderName
            );
        case ComposeUniqueState.GroupCalendar:
            return format(
                actionMessageMap[FilePickerActionMessageType.AttachGroupCalendar](),
                fileProviderName
            );
        case ComposeUniqueState.Encrypted:
            return format(
                actionMessageMap[FilePickerActionMessageType.ShareEncryptedMessage](),
                fileProviderName
            );
        default:
            return null;
    }
}
